define('shared/initializer/form/adapters/mixins/Worldpayable',[
    '$',
    'kernel/ui/Blocker',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/lib/URI',
    'shared/util/state',
    'shared/util/state/adapters/pending',
    'shared/my/identity',
    'shared/my/cmus',
    'shared/page/runmode',
    'shared/remote/order/get',
    'shared/initializer/form/constants',
],
function (
    $,
    Blocker,
    ctor,
    RSVP,
    console,
    URI,
    state,
    pendingAdapter,
    getMyIdentity,
    getCMus,
    getRunMode,
    getOrder,
    constants
) {
    'use strict';

    var instanceCount = 0;
    var promiseUpdateURLs;
    var RETRY_TIMEOUT = 30;
    var LOG_ID = 'shared/initializer/form/adapters/WorldpayPayment:';
    var URL_API = '/checkout/payment/prepareworldpay?offerid=[OFFERID]&cmus=[CMUS]&ctr';
    var URL_RETURN = window.location.pathname + window.location.search + '#';
    var URL_BASE = location.protocol + '//' + location.host;
    var URL_HELPER = '/etc/designs/b2c/others/worldpay-helper';
    var URL_WORLDPAY_LIB = 'https://payments.worldpay.com/resources/hpp/integrations/embedded/js/hpp-embedded-integration-library.js';
    var STATUS = {
        's':'success',
        'p':'pending',
        'e':'error',
        'f':'failure',
        'c':'cancell'
    };

    function updatePageEnding() {
        if (promiseUpdateURLs) {
            return promiseUpdateURLs;
        }

        promiseUpdateURLs = RSVP.resolve()
            .then(function(){
                return getRunMode();
            })
            .then(function(runMode){
                if (runMode === 'author') {
                    // URL_RETURN += '.html';
                    URL_HELPER += '.html';
                }
                else {
                    // URL_RETURN += '/';
                    URL_HELPER += '/';
                }
            });

        return promiseUpdateURLs;
    }

    function getIFrameUrl() {
        var me = this;
        var url = URL_API;

        return RSVP.all([
            getMyIdentity(), 
            state.retrieve(constants.State.OrderOfferId), 
            getCMus()
        ])
        .then(function(values){
            var memberID = values[0];
            var offerID = Array.isArray(values[1])?values[1][0]:values[1];
            var cmus = values[2];

            url = updateUrl(url, 'MEMBERID', memberID);
            url = updateUrl(url, 'OFFERID', offerID);
            url = updateUrl(url, 'CMUS', cmus);
            url = updateUrl(url, 'RETURNURL', URL_BASE + URL_RETURN);

            return url;
        })
        .then(function(){
            console.log(LOG_ID, 'The worldpay iframe API url is: ', url);
            
            return $.post(url, {dataType: 'json'}).promise();
        })
        .then(function(data){
            if (data == null || data.payment_url == null || data.success !== true) {
                return RSVP.reject('Server failed to return iframe URL');
            }

            return RSVP.resolve()
                .then(function(){
                    me._worldpay = data;
                    console.log(LOG_ID, 'The worldpay order id is: ', data.order_id);
                    return state.adapters.add(pendingAdapter)
                        .then(function(){
                            return state.push('pending.order.id', data.order_id);
                        });
                })
                .then(function(){
                    console.log(LOG_ID, 'The worldpay iframe url is: ', data.payment_url);
                    return data.payment_url;
                });
        });
    }

    function getStatusFromUrl() {
        var uri = new URI(window.location.href);
        var hash = uri.hash();
        hash = hash.substr(1);
        uri = new URI(hash);
        var query = uri.query(true);
        var status = query.s;
        if (status in STATUS) {
            return STATUS[status];
        }
        else {
            return null;
        }
    }

    function wait4PaymentFinish() {
        return new RSVP.Promise(function(rs){
            var handle = setInterval(function(){
                var result = getStatusFromUrl();
                if (result) {
                    clearInterval(handle);
                    console.log('The worldpay returned url is', location.hash);
                    rs(result);
                }
            }, 100);
        });
    }

    function updateUrl(str, name, value) {
        var regex = new RegExp('\\[' + name + '\\]', 'g');
        return str.replace(regex, value);
    }

    function loadIFrame(id) {
        var me = this;
        var url;
        var $html = $('html');
        var debug;
        var country;
        var language;
        var windowOnloadBackup;
        var dummy = function(){};
        var startWorldpay;

        if (id == null) {
            throw new Error('No id is specified');
        }

        var $el = $('#'+id);
        if ($el.length <= 0) {
            throw new Error('Targeted placeholder is not found');
        }

        if ($html.hasClass('runmode-qa')) {
            debug = true;
        }

        return RSVP.all([
                getIFrameUrl.call(me), 
                state.retrieve('page.language'), 
                state.retrieve('page.market')
            ])
            .then(function(values){
                url = values[0];
                language = values[1];
                country = values[2];

                return $
                    .getScript(URL_WORLDPAY_LIB)
                    .promise();
            })
            .then(function(){
                return new RSVP.Promise(function(rs){
                    setTimeout(rs, 0);
                });
            })
            .then(function(){
                // Below is a hack to capture the stupid worldpay start up function
                // according to worldpay the official way to do it is to trigger onload event
                // twice which is rather stupid and trouble making
                //
                // Here is the quote from 
                // http://support.worldpay.com/support/kb/gg/hpp/Content/Content4/Integration%20single%20page%20app.htm 
                //
                // For an iframe integration, the payment page content is injected into the webpage by way of a 
                // ‘window.onload’ event. This may cause issues in a single-page application website where the 
                // content is loaded once and then dynamically altered through the use of technologies such as AJAX.
                // To resolve this, you can have an additional ‘window.onload’ event triggered after setting up 
                // the integration library. The simplest mechanism for doing this is by using the JavaScript 
                // 'dispatchEvent' function. For more detail, see the advanced iframe example in Example webpage code.

                windowOnloadBackup = window.onload;
                window.onload = dummy;

                /* global WPCL:true */
                var libraryObject = window.worldPayLibObject = new WPCL.Library();
                libraryObject.setup({
                    type: 'iframe',
                    iframeIntegrationId: 'worldPayLibObject',
                    iframeHelperURL: URL_BASE + URL_HELPER,
                    iframeBaseURL: URL_BASE,
                    url: url,
                    target: id,
                    debug: debug,
                    language: language,
                    country: country,
                    successURL: URL_BASE + URL_RETURN + '?s=s',
                    cancelURL: URL_BASE + URL_RETURN + '?s=c',
                    failureURL: URL_BASE + URL_RETURN + '?s=f',
                    pendingURL: URL_BASE + URL_RETURN + '?s=p',
                    errorURL: URL_BASE + URL_RETURN + '?s=e'
                });
            })
            .then(function(){
                if (window.onload != dummy) {
                    startWorldpay = window.onload;
                }

                window.onload = windowOnloadBackup;

                startWorldpay();
                $el.find('iframe').css({
                    width: '100%'
                });
            });
    }

    function waitForCallback(func) {
        var me = this;
        me.blocker.block();
        return new RSVP.Promise(function(rs, rj){
            var tryCount = 0;
            function loop(){
                func.call(me).then(function(result){
                    if (result) {
                        rs();
                    }
                    else {
                        tryCount++;
                        if (tryCount > RETRY_TIMEOUT) {
                            var err = new Error(
                                'Timed out waiting for payment to go throught,' + 
                                ' please contact our service personnel with order renference number:' + 
                                me._worldpay.order_id
                            );
                            err.type = 'payment.timeout';
                            err.orderId = me._worldpay.order_id;
                            rj(err);
                        }
                        else {
                            setTimeout(loop, 1000);
                        }
                    }
                }, function(error){
                    var err = new Error('Payment failure: ' + error + '\n<br/>' + 
                        'Please contact our service personnel with order renference number:' + 
                        me._worldpay.order_id
                    );
                    err.type = 'payment.failed.order.status';
                    err.orderId = me._worldpay.order_id;
                    rj(err);
                });
            }

            loop();
        })
        .then(function(){
            me.blocker.resume();
        }, function(err){
            me.blocker.resume();
            return RSVP.reject(err);
        });
    }

    function monitorPaymentProcess() {
        var me = this;
        var result;
        return wait4PaymentFinish.call(me)
            .then(function(value){
                result = value;
                console.log(LOG_ID, 'Worldpay payment result is', result);
                // clear hash
                location.hash = '';
                if (result !== STATUS.s) {
                    var err = new Error(
                        'Worldpay payment failed, please contact our service personnel with' +
                        ' order reference number:' + me._worldpay.order_id
                    );
                    err.orderId = me._worldpay.order_id;
                    err.type = 'payment.failed.card.rejected';
                    err.fatal = false;
                    return RSVP.reject(err);
                }
            })
            // make sure order status is ordered
            // if its pending, wait for a while
            .then(function(){
                return waitForCallback.call(me, function(){
                    return getOrder({
                        id: me._worldpay.order_id,
                        cache: {
                            bypass: true
                        }
                    })
                    .then(function(orderInfo){
                        var status = orderInfo.Status.toLowerCase();
                        if (status === 'ordered') {
                            return RSVP.resolve(true);
                        }
                        else if (status === 'new' || status === 'pending') {
                            return RSVP.resolve(false);
                        }
                        else {
                            return RSVP.reject('Order status is "' + status + '"');
                        }
                    });
                });
            })
            .then(function(){
                me.emit('payment.done', result);
            });
    }

    var Ctor = function() {
        var me = this;
        me.blocker = null;
        me._count = instanceCount++;
        me._$wrapper = null;
        me._worldpayInstanceID = 'worldpay-instance-' + me._count;
    };

    var p = Ctor.prototype;

    p.doPageLoad = function(){
        var me = this;
        var id = me._worldpayInstanceID;
        return RSVP.resolve()
            .then(function(){
                return updatePageEnding();
            })
            .then(function(){
                me._$wrapper = me._$wrapper || $('<div></div>');
                me._$wrapper
                    .attr('id', id)
                    .css({
                        'min-height': '300px',
                        'position': 'relative'
                    })
                    .prependTo(me.$form.find('.row'));
                me.blocker = new Blocker(me._$wrapper[0]);
                me.blocker.block();
            })
            .then(function(){
                return loadIFrame.call(me, id);
            })
            .then(function(){
                me.blocker.resume();
                me.emit('payment.start');
            });
    };

    p.doSubmit = function() {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                // simulate the timing of submit finishing
                return monitorPaymentProcess.call(me);
            });
    };

    p.doError = function() {
        var me = this;
        me._$wrapper.remove();
        me.blocker.resume();
        me.blocker = null;
        return RSVP.resolve();
    };

    return Ctor;
});
